let config = {
  mainCallout: {
    text: 'If you are having issues locating an incarcerated person, call the Office of Community Justice and Oureach \
           at (215)685-7093 or (215)685-7711.',
  },
};

export default config;
